import AbstractRule from './AbstractRule';
import {AnySchema} from 'yup';

export default class NumericRule extends AbstractRule {
    protected name = 'numeric';

    mutateScheme<S extends AnySchema>(scheme: S): S {
        return scheme.typeError('Validator.is_should_be_numeric');
    }
}
